define( 'models/partModel',[], function() {
	var model = Backbone.Model.extend( {
		fieldErrors: {},

		defaults: {
			errors: false,
			visible: true,
			title: ''
		},

		initialize: function() {
			this.filterFormContentData();
			this.listenTo( this.get( 'formContentData' ), 'change:errors', this.maybeChangeActivePart );
			// Repeater children live outside formContentData, so their error changes
			// never reach maybeChangeActivePart above. Without this, a Repeater's
			// required-field error only clears on the next Next/Submit click instead
			// of live, the moment the user corrects it — unlike every other field type.
			this.listenTo( nfRadio.channel( 'fields' ), 'add:error', this.maybeRepeaterError );
			this.listenTo( nfRadio.channel( 'fields' ), 'remove:error', this.maybeRepeaterError );
			this.fieldErrors[ this.cid ] = [];
			this.on( 'change:visible', this.changeVisible, this );
            // Cast order as a number to avoid string comparison.
            this.set( 'order', Number( this.get( 'order' ) ) );
		},

		filterFormContentData: function() {
			if ( ! this.get( 'formContentData' ) ) return;
			var formContentData = this.get( 'formContentData' );
			/*
			 * Update our formContentData by running it through our fromContentData filter
			 */
			var formContentLoadFilters = nfRadio.channel( 'formContent' ).request( 'get:loadFilters' );
			/* 
			* Get our second filter, this will be the one with the highest priority after MP Forms.
			*/
			var sortedArray = _.without( formContentLoadFilters, undefined );
			var callback = sortedArray[ 1 ];
			/*
			 * If our formContentData is an empty array, we want to pass the "empty" flag as true so that filters know it's purposefully empty.
			 */
			var empty = ( 0 == formContentData.length ) ? true : false;
			/*
			 * TODO: This is a bandaid fix to prevent forms with layouts and parts from freaking out of layouts & styles are deactivated.
			 * If Layouts is deactivated, it will try to grab the layout data and show the fields on the appropriate parts.
			 */
			if ( 'undefined' == typeof formContentLoadFilters[4] && _.isArray( formContentData ) && 0 != formContentData.length && 'undefined' != typeof formContentData[0].cells ) {
				/*
				 * We need to get our field keys from our layout data.
				 * Layout data looks like:
				 * Rows
				 *   Row
				 *     Cells
				 *       Cell
				 *         Fields
				 *       Cell
				 *         Fields
				 *   Row
				 *     Cells
				 *       Cell
				 *         Fields  
				 */
				var partFields = [];
				var cells = _.pluck( formContentData, 'cells' );
				_.each( cells, function( cell ) {
					var fields = _.flatten( _.pluck( cell, 'fields' ) );
					partFields = _.union( partFields, fields );
				} );

				formContentData = partFields;

				this.set( 'formContentData', formContentData );
			}

			this.set( 'formContentData', callback( formContentData, this.collection.formModel, empty, formContentData ) );
		},

		maybeChangeActivePart: function( fieldModel ) {
			/*
			 * If we have an error on this part, add an error to our part model.
			 *
			 * If we are on a part that has a higher index than the current part, set this as current.
			 */
			if ( 0 < fieldModel.get( 'errors' ).length ) {
				this.set( 'errors', true );
				this.fieldErrors[ this.cid ].push( fieldModel.get( 'key' ) );
				// this.set( 'fieldErrors', fieldModel.get( 'key' ) );
				if (
					this.collection.getElement() != this &&
					this.collection.indexOf( this.collection.getElement() ) > this.collection.indexOf( this )

				) {
					this.collection.setElement( this );
				}
			} else {
				this.fieldErrors[ this.cid ] = _.without( this.fieldErrors[ this.cid ], fieldModel.get( 'key' ) );
				if ( 0 == this.fieldErrors[ this.cid ].length ) {
					this.set( 'errors', false );
				}
			}
		},

		validateFields: function() {
			this.get( 'formContentData' ).validateFields();
		},

		changeVisible: function() {
			if ( this.get( 'visible' ) ) {
				this.get( 'formContentData' ).showFields();
				this.cascadeRepeaterChildrenVisible( true );
			} else {
				this.get( 'formContentData' ).hideFields();
				this.cascadeRepeaterChildrenVisible( false );
			}
		},

		// Returns the `key` of every field directly in this part's formContentData
		// (not Repeater children, which live outside it — see getRepeaterFieldIds).
		// Handles both flat fieldCollection (no Layouts) and Row→Cell structure
		// (with Layouts), same as getRepeaterFieldIds below. Used by
		// conditionalLogic.js to scope its post-show/hide re-check to only the
		// Conditional Logic rules that actually reference a field this part just
		// forced visible/hidden via showFields()/hideFields() (#270) — instead of
		// blindly re-checking every condition in the form, including unrelated
		// ones whose own field-value-driven status may not have settled yet.
		getFieldKeys: function() {
			var keys = [];
			var formContentData = this.get( 'formContentData' );
			if ( ! formContentData || ! formContentData.each ) return keys;

			formContentData.each( function( rowOrFieldModel ) {
				// Flat case: each model in the collection is a field model
				if ( rowOrFieldModel.get( 'key' ) ) {
					keys.push( rowOrFieldModel.get( 'key' ) );
					return;
				}

				// Layouts case: row model has a 'cells' Backbone Collection
				var cells = rowOrFieldModel.get( 'cells' );
				if ( ! cells ) return;
				var cellItems = cells.models ? cells.models : cells;
				_.each( cellItems, function( cell ) {
					if ( ! cell ) return;
					var fields = cell.get ? cell.get( 'fields' ) : cell.fields;
					var fieldItems = fields && fields.models ? fields.models : ( fields || [] );
					_.each( fieldItems, function( fieldData ) {
						if ( ! fieldData ) return;
						var fKey = fieldData.get ? fieldData.get( 'key' ) : fieldData.key;
						if ( fKey ) keys.push( fKey );
					} );
				} );
			} );

			return keys;
		},

		// Returns all Repeater field IDs in this part's formContentData.
		// Handles both flat fieldCollection (no Layouts) and Row→Cell structure (with Layouts).
		// Layouts stores fields inside Backbone Collection cells, not as direct models.
		getRepeaterFieldIds: function() {
			var ids = [];
			var formContentData = this.get( 'formContentData' );
			if ( ! formContentData || ! formContentData.each ) return ids;

			formContentData.each( function( rowOrFieldModel ) {
				// Flat case: each model in the collection is a field model
				if ( 'repeater' === rowOrFieldModel.get( 'type' ) ) {
					ids.push( String( rowOrFieldModel.get( 'id' ) ) );
					return;
				}

				// Layouts case: row model has a 'cells' Backbone Collection
				// Use .models — Backbone Collections don't expose numeric indices
				var cells = rowOrFieldModel.get( 'cells' );
				if ( ! cells ) return;
				var cellItems = cells.models ? cells.models : cells;
				_.each( cellItems, function( cell ) {
					if ( ! cell ) return;
					var fields = cell.get ? cell.get( 'fields' ) : cell.fields;
					var fieldItems = fields && fields.models ? fields.models : ( fields || [] );
					_.each( fieldItems, function( fieldData ) {
						if ( ! fieldData ) return;
						var fType = fieldData.get ? fieldData.get( 'type' ) : fieldData.type;
						var fId   = fieldData.get ? fieldData.get( 'id' )   : fieldData.id;
						if ( 'repeater' === fType ) {
							ids.push( String( fId ) );
						}
					} );
				} );
			} );

			return ids;
		},

		// Returns child field models for Repeater fields that are individually
		// hidden (e.g., via conditional logic) within this part's formContentData.
		// Used by partErrors() to suppress them during validation so validateRequired
		// skips them, and to scrub their stale errors from formModel.fieldErrors.
		getHiddenRepeaterChildModels: function() {
			var children = [];
			var formContentData = this.get( 'formContentData' );
			if ( ! formContentData || ! formContentData.each ) return children;

			formContentData.each( function( rowOrFieldModel ) {
				// Flat case: each model in the collection is a field model
				if ( 'repeater' === rowOrFieldModel.get( 'type' ) ) {
					if ( ! rowOrFieldModel.get( 'visible' ) ) {
						var fieldset = nfRadio.channel( 'field-repeater' ).request( 'get:repeaterFields', String( rowOrFieldModel.get( 'id' ) ) );
						if ( fieldset && fieldset.fields ) {
							children = children.concat( fieldset.fields );
						}
					}
					return;
				}

				// Layouts case: row model has a 'cells' Backbone Collection
				var cells = rowOrFieldModel.get( 'cells' );
				if ( ! cells ) return;
				var cellItems = cells.models ? cells.models : cells;
				_.each( cellItems, function( cell ) {
					if ( ! cell ) return;
					var fields = cell.get ? cell.get( 'fields' ) : cell.fields;
					var fieldItems = fields && fields.models ? fields.models : ( fields || [] );
					_.each( fieldItems, function( fieldData ) {
						if ( ! fieldData ) return;
						var fType    = fieldData.get ? fieldData.get( 'type' )    : fieldData.type;
						var fId      = fieldData.get ? fieldData.get( 'id' )      : fieldData.id;
						var fVisible = fieldData.get ? fieldData.get( 'visible' ) : fieldData.visible;
						if ( 'repeater' === fType && ! fVisible ) {
							var fieldset = nfRadio.channel( 'field-repeater' ).request( 'get:repeaterFields', String( fId ) );
							if ( fieldset && fieldset.fields ) {
								children = children.concat( fieldset.fields );
							}
						}
					} );
				} );
			} );

			return children;
		},

		// Fires on every field's add:error/remove:error, form-wide. Cheap no-op for
		// fields outside this part; for a Repeater child that belongs to this part,
		// re-syncs this.errors immediately so the part-tab UI updates live instead
		// of waiting for the next Next/Submit click.
		maybeRepeaterError: function( fieldModel ) {
			var formModel = this.collection && this.collection.formModel;
			if ( ! formModel || ! fieldModel || 'undefined' === typeof fieldModel.get( 'formID' ) ) return;

			if ( this.hasRepeaterChildErrors( formModel ) ) {
				this.set( 'errors', true );
			} else if ( 0 === this.fieldErrors[ this.cid ].length ) {
				this.set( 'errors', false );
			}
		},

		// Returns true if formModel.fieldErrors contains errors for any Repeater
		// child that belongs to this part. Used by partCollection.partErrors() to
		// block Next navigation when mp_validate=1 and a Repeater child is invalid.
		hasRepeaterChildErrors: function( formModel ) {
			var fieldErrors = formModel.get( 'fieldErrors' );
			if ( 0 === _.size( fieldErrors ) ) return false;

			return _.any( this.getRepeaterFieldIds(), function( repId ) {
				var prefix = repId + '.';
				return _.any( Object.keys( fieldErrors ), function( key ) {
					return 0 === key.indexOf( prefix );
				} );
			} );
		},

		cascadeRepeaterChildrenVisible: function( visible ) {
			var formModel = this.collection && this.collection.formModel;
			var fieldErrors = formModel && formModel.get( 'fieldErrors' );

			_.each( this.getRepeaterFieldIds(), function( repeaterFieldId ) {
				// nfAllRepeaterFieldsModels persists across view re-renders;
				// fieldModel.get('sets') may be cleared when the view is destroyed.
				var fieldset = nfRadio.channel( 'field-repeater' ).request( 'get:repeaterFields', repeaterFieldId );
				if ( fieldset && fieldset.fields ) {
					_.each( fieldset.fields, function( childModel ) {
						childModel.set( 'visible', visible );
						if ( ! visible ) {
							var errors = childModel.get( 'errors' );
							if ( errors && errors.get( 'required-error' ) ) {
								errors.remove( errors.get( 'required-error' ) );
								childModel.trigger( 'change:errors', childModel );
							}
						}
					} );
				}

				// Scrub formModel.fieldErrors by prefix — the channel-based remove:error
				// silently no-ops when stale instances accumulate in nfAllRepeaterFieldsModels.
				if ( ! visible && fieldErrors ) {
					var prefix = repeaterFieldId + '.';
					_.each( Object.keys( fieldErrors ), function( key ) {
						if ( 0 === key.indexOf( prefix ) ) {
							delete fieldErrors[ key ];
						}
					} );
				}
			} );

			if ( ! visible && formModel && 0 === _.size( formModel.get( 'fieldErrors' ) ) ) {
				var formId = formModel.get( 'id' );
				nfRadio.channel( 'form-' + formId ).request( 'remove:error', 'field-errors' );
				// Guard: during early initialization the form may not yet be registered
				// with the app channel. Skip the trigger — the submit button is enabled
				// by default so there is nothing to re-enable at that point.
				if ( nfRadio.channel( 'app' ).request( 'get:form', formId ) ) {
					nfRadio.channel( 'form-' + formId ).trigger( 'enable:submit' );
				}
			}
		}
	} );

	return model;
} );

